import Api from '../services/Api';
import { ErrorDictionary } from '../pages/Components/Helpers/ErrorDictionary';
import { UnidadeMedidaRequest, Response } from './Types';

class UnidadeMedidaController {
  public static async Listar(request: UnidadeMedidaRequest): Promise<Response> {
    try {
      console.log('Controller UnidadeMedida Listar');
      console.log(request);

      const response = await Api.post('api/unidademedida/Listar', request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async ListarUnico(UnidadeMedidaId: number): Promise<Response> {
    try {
      console.log('Controller UnidadeMedida Listar Unico');
      console.log(UnidadeMedidaId);

      const response = await Api.get(
        `api/unidademedida/ListarUnico/${UnidadeMedidaId}`
      );

      const object = response?.data;

      const retorno: Response = {
        StatusCode: response.status,
        Data: object[0],
      };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Adicionar(
    request: UnidadeMedidaRequest
  ): Promise<Response> {
    try {
      console.log('Controller UnidadeMedida Adicionar');
      console.log(request);

      const response = await Api.post(`api/unidademedida/Adicionar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Atualizar(
    request: UnidadeMedidaRequest
  ): Promise<Response> {
    try {
      console.log('Controller UnidadeMedida Atualizar');
      console.log(request);

      const response = await Api.put(`api/unidademedida/Atualizar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Excluir(
    request: UnidadeMedidaRequest
  ): Promise<Response> {
    try {
      console.log('Controller UnidadeMedida Excluir');
      console.log(request);

      const response = await Api.put(`api/unidademedida/Excluir`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }
}

export default UnidadeMedidaController;
